import React from "react";

const BirthIcon = ({ color = "#0B65B5" }) => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 0.0930176C13.2449 0.0930499 13.4813 0.182974 13.6644 0.345733C13.8474 0.508492 13.9643 0.732766 13.993 0.976017L14 1.09302V2.09302H16C16.5046 2.09286 16.9906 2.28342 17.3605 2.62651C17.7305 2.9696 17.9572 3.43986 17.995 3.94302L18 4.09302V16.093C18.0002 16.5976 17.8096 17.0836 17.4665 17.4536C17.1234 17.8235 16.6532 18.0502 16.15 18.088L16 18.093H2C1.49542 18.0932 1.00943 17.9026 0.639452 17.5595C0.269471 17.2164 0.0428434 16.7462 0.00500021 16.243L1.00268e-07 16.093V4.09302C-0.000159579 3.58844 0.190406 3.10245 0.533497 2.73247C0.876588 2.36249 1.34684 2.13586 1.85 2.09802L2 2.09302H4V1.09302C4.00028 0.838138 4.09788 0.592985 4.27285 0.407649C4.44782 0.222313 4.68695 0.110783 4.94139 0.0958455C5.19584 0.0809083 5.44638 0.163692 5.64183 0.327282C5.83729 0.490873 5.9629 0.722922 5.993 0.976017L6 1.09302V2.09302H12V1.09302C12 0.827801 12.1054 0.573447 12.2929 0.385911C12.4804 0.198374 12.7348 0.0930176 13 0.0930176ZM16 9.09302H2V16.093H16V9.09302ZM16 4.09302H2V7.09302H16V4.09302Z"
        fill={color}
      />
    </svg>
  );
};

export default BirthIcon;
